define('modules/editor/models/property_groups/image_content',['require','exports','module','./base','../editorstate','env'],function(require, exports, module){
  "use strict";
  var BasePropertyGroup = require("./base"),
      EditorState = require("../editorstate"),
      config = require("env");

  module.exports = BasePropertyGroup.extend({
    name: "image:content",
    properties: ["altText", "title", "linkTarget", "imageUrl", "linkUrl", "imageId"],
    getImageSize: function(){
      //creates an in-memory image to get the real height/width
      var self = this;
      $("<img />")
        .load(function(){
          self.parent.getPropertyGroup("geometry").set({
            "width": this.width,
            "height": this.height
          });
        })
        .attr("src", this._generateImageUrl());
    },
    adjustImageSize: function(section){
      var self = this,
          container = section.getPropertyGroup("sectionGeometry");
      $("<img />")
        .load(function(){
          var geo = self.parent.getPropertyGroup("geometry"),
              maxWidth = container.get("width") - geo.get("left"),
              maxHeight = container.get("height") - geo.get("top"),
              ratio = this.width/this.height,
              width = Math.min(this.width, maxWidth, Math.round(maxHeight * ratio)),
              height = Math.round(width / ratio);
          geo.set({
            width: width,
            height: height
          });
        })
        .attr("src", this._generateImageUrl());
    },
    applyStyles: function($el){
      var $img, $link, linkUrl;

      if(!this.get("imageUrl")) {
        //render empty helper (it's in the image template)
        return;
      }

      $el.empty();

      $img = this._generateImageMarkup();

      $img
        .css("height", "100%")
        .css("width", "100%")
        .attr("src", this._generateImageUrl())
        .attr("alt", this.get("altText"))
        .attr("title", this.get("title"));

      linkUrl = this.get("linkUrl").trim();

      if(linkUrl !== ""){
        $link = $("<a>")
          .attr("href", linkUrl)
          .attr("target", this.get("linkTarget"))
          .append($img);

        $el.html($link);
      }
      else {
        $el.html($img);
      }
    },
    _generateImageMarkup: function () {
      return EditorState.getAMPState() && EditorState.isGenerateMode() ?
        this._generateImageAMPMarkup() :
        this._generateImageHTMLMarkup();
    },
    _generateImageAMPMarkup: function () {
      return $('<amp-img />').attr({
        'width': '300',
        'height': '200',
        'layout': 'responsive'
      }).addClass('unknown-size');
    },
    _generateImageHTMLMarkup: function () {
      return $('<img />');
    },
    _generateImageUrl: function(){
      var url = this.get("imageUrl");
      if (!url) {
        return "";
      }

      url = "/img/assets/" + url;
      if (config.cdnDomain) {
        return config.cdnDomain + url;
      }
      if (!EditorState.isGenerateMode()) {
        return config.apiHost.replace("https:", "") + url;
      }
      return url;
    },
    validators: {
      linkUrl: function(attrs){
        return attrs.linkUrl === "" || this.isValidUrl(attrs.linkUrl) || this.isValidAnchorName(attrs.linkUrl);
      }
    }

  });
});

